import { checkFile, fileErrorText } from '../core/file-upload';

/**
 * Why a picked file cannot be a profile or group photo, or null when it can. It is cropped to a square and shrunk in
 * the browser before upload, so any picture the file checks accept will do.
 */
export function photoPickProblem(file: File): string | null {
  const refused = checkFile(file, file.name);
  if (refused) return fileErrorText(refused, file.name);
  return file.type.startsWith('image/') ? null : 'Choose a photo (JPEG, PNG or WebP).';
}
